import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children, roles }) => {
  const isAuthenticated = useSelector((state) => state.login.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to="/homePage" /*state={{ from: location }}*/ />;
  }
  return children;
};

export default PublicRoute;

// let location = useLocation();
// const user = useSelector((state) => state.login.userData);
//   const userHasRequiredRole = user && roles.includes(user.role) ? true : false;
//   if (isAuthenticated && !userHasRequiredRole) {
//     return <> NO ACCESS </>; // build your won access denied page (sth like 404)
//   }
//   https://dev.to/iamandrewluca/private-route-in-react-router-v6-lg5
// https://adarshaacharya.com.np/blog/role-based-auth-with-react-router-v6
